import React, { Component } from 'react'
import css from './styles.scss'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { setShowCaveonIdModal } from '../../../js/actions/actions'

export class Home extends Component {
  constructor () {
    super()
    this.state = {
      slideOffset: 0
    }
    this.lines = {}
  }
  componentDidMount () {
    const { auth: { authenticated }, history } = this.props
    if (authenticated) {
      history.push('/items')
    }
  }
  moveSlider = amount => {
    this.setState({
      slideOffset: amount
    })
  }

  openCaveonIdModal = () => {
    this.props.dispatch(setShowCaveonIdModal(true))
  }

  render () {
    return (
      <div className={css.loginWrapper}>
        
        <div className={css.wrapper} >
          <div className={css.columnright}>
              <span className={css.imgbackground}>
                  <img src="/images/smartitem-api-logo2.png" alt="Caveon SmartItem API"/>
              </span>
              <div className={css.loginlinks}>
                  <button onClick={ this.openCaveonIdModal } className={css.ctaButton}>Sign in with Caveon ID</button>
                  <a href='mailto:alison.foster@caveon.com' className={css.ctaButton}>Request a Demo</a>
              </div>
              <div className={css.learnmore}>
              <a href='https://caveon.com/innovations-in-testing/smartitem/' target="_blank" className={css.learnmore}>Learn more about SmartItems.</a>
              </div>
          </div>
          <div className={css.columnleft}>
          <img src="https://caveon-content.s3-us-west-2.amazonaws.com/smart-splash1.jpg" alt="SmartItems API Datasource" width="100%"/>
            <section className={css.section1}>
              <h2>Secure and Innovative Tools- On the Go</h2>
              <h3>Plug the Benefits of AIG and SmartItems Into Your Own System</h3>
            </section>
            <section className={css.section2}>
              <p>There’s no need to change your test development and delivery tools to harness the benefits of SmartItems and Automated Item Generation (AIG). Our API will integrate with your existing tools, allowing you to:</p>

              <div className={css.row}>
                <div className={css.col1}>
                  <img src="https://caveon-content.s3-us-west-2.amazonaws.com/smart-splash2.jpg" alt="SmartItems API Integrations" width="100%"/>
                </div>
                <div className={css.col2}>
                  <h3>Develop tests using SmartItems</h3>
                </div>
                </div>
                <div className={css.row}>
                <div className={css.col1}>
                  <img src="https://caveon-content.s3-us-west-2.amazonaws.com/smart-splash3.jpg" alt="SmartItem API Generate Items" width="100%"/>
                </div>
                <div className={css.col2}>
                 <h3>Generate hundreds or thousands of items with Caveon AIG</h3>
                </div>


                </div>
                <div className={css.row}>
                <div className={css.col1}>
                  <img src="https://caveon-content.s3-us-west-2.amazonaws.com/smart-splash4.jpg" alt="SmartItem API Automatic Item Generation" width="100%"/>
                </div>
                <div className={css.col2}>
                 <h3>Reduce the negative effects of content exposure</h3>
                </div>
              </div>

              <div className={css.row}>
                <div className={css.col1}>
                  <img src="https://caveon-content.s3-us-west-2.amazonaws.com/smart-splash5.jpg" alt="SmartItem API AIG" width="100%"/>
                </div>
                <div className={css.col2}>
                  <h3>Reduce the negative effects of testwiseness</h3>
                </div>
              </div>
              <h4>The results speak for themselves:</h4>
            </section>
            <section className={css.section3}>
              <blockquote>
                “SmartItems are invulnerable to cheating and theft, relieving SailPoint of the same security concerns that have plagued every other IT certification program for the past three decades.”
              </blockquote>
              <small><p><strong>—Arthur Altman</strong> <br/> Program Manager, Global Education Services<br/> Sailpoint Technologies Holdings</p></small>
            </section>
          </div>
        </div>        
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth } = state
  return {
    app,
    auth
  }
}

export default withRouter(connect(mapStateToProps)(Home))



// WEBPACK FOOTER //
// /app/js/components/Home/index.js